
/**
 * Format a number to a string with a short suffix.
 *
 * @param {number} num The number to format.
 * @returns {string} The formatted string.
 */
export function formatNumber(num) {
    if (num >= 1000000) {
        // If the number is greater than or equal to 1 million,
        // return a string with the number divided by 1 million,
        // rounded to one decimal place, and suffixed with "M+".
        let numberFormat = (num / 1000000).toFixed(1).replace(/\.0$/, '');
        return `<span data-value="${numberFormat}" class="number-value">${numberFormat}</span><span class="suffix">M+</span>`;
    }
    
    if (num >= 1000) {
        // If the number is between 1 thousand and 1 million,
        // return a string with the number divided by 1 thousand,
        // rounded to one decimal place, and suffixed with "K+".
        let numberFormat = (num / 1000).toFixed(1).replace(/\.0$/, '');
        return `<span data-value="${numberFormat}" class="number-value">${numberFormat}</span><span class="suffix">K+</span>`;
    }
    
    if (num > 0) {
        // If the number is positive, return a string with the number
        // and a "+" suffix.
        return `<span data-value="${num}" class="number-value">${num}</span></span><span class="suffix">+</span>`;
    }
    
    // Otherwise, return the number as a string.
    return num.toString();
}
